export default __webpack_public_path__ + "static/media/lasttime_4.82565cf2.jpg";